import * as React from "react";
import "../styles/App.css";
import "react-select/dist/react-select.css";
import BullCodeSelector from "./containers/BullCodeSelectorContainer";
import CsvUploader from "./containers/CsvUploaderContainer";
import InbreedingCalculatorResultsGrid from "./components/Table";

function App() {
  return (
    <div className="App">
      <CsvUploader />
      <BullCodeSelector />
      <InbreedingCalculatorResultsGrid />
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/scripts/App.tsx